module.exports = __webpack_public_path__ + "img/supervised.0a401274.png";